import { PageHeader, PageHeaderProps } from "antd";

export const AppPageHeader = (props: PageHeaderProps) => (
  <PageHeader {...props} style={{ padding: "1rem 0" }} />
);
